import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "automation-controls" }
const _hoisted_2 = ["min", "max", "step", "value"]
const _hoisted_3 = ["min", "max", "step", "value"]
const _hoisted_4 = {
  id: "speed",
  ref: "speed",
  type: "number"
}
const _hoisted_5 = {
  name: "type",
  id: "type",
  ref: "type"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Automate", -1)),
    _createElementVNode("section", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("label", { for: "min" }, "min", -1)),
      _createElementVNode("input", {
        id: "min",
        ref: "min",
        type: "range",
        min: _ctx.inputAttributes.min,
        max: _ctx.inputAttributes.max,
        step: _ctx.inputAttributes.step,
        value: _ctx.inputAttributes.min
      }, null, 8, _hoisted_2),
      _cache[5] || (_cache[5] = _createElementVNode("label", { for: "max" }, "max", -1)),
      _createElementVNode("input", {
        id: "max",
        ref: "max",
        type: "range",
        min: _ctx.inputAttributes.min,
        max: _ctx.inputAttributes.max,
        step: _ctx.inputAttributes.step,
        value: _ctx.inputAttributes.max
      }, null, 8, _hoisted_3),
      _cache[6] || (_cache[6] = _createElementVNode("label", { for: "speed" }, "speed (ms)", -1)),
      _createElementVNode("input", _hoisted_4, null, 512),
      _cache[7] || (_cache[7] = _createElementVNode("label", { for: "type" }, "type", -1)),
      _createElementVNode("select", _hoisted_5, _cache[3] || (_cache[3] = [
        _createElementVNode("option", { value: "random" }, "random", -1)
      ]), 512),
      (!_ctx.isAutomating)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.automateValues && _ctx.automateValues(...args)))
          }, "Go"))
        : _createCommentVNode("", true),
      (_ctx.isAutomating)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.automateValues && _ctx.automateValues(...args)))
          }, "Stop"))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleRemove && _ctx.handleRemove(...args)))
      }, "Remove")
    ])
  ], 64))
}